"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyles = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var Jumbo = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.sansSerif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.jumbo.fontSize;
});
var Big = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.sansSerif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.big.fontSize;
});
var Normal = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.sansSerif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.normal.fontSize;
});
var Small = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.sansSerif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.small.fontSize;
});
var Micro = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.sansSerif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.micro.fontSize;
});
var Notification = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.sansSerif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.notification.fontSize;
});
var Quote = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.serif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.quote.fontSize;
});
var Author = styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.serif;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.author.fontSize;
});
var baseCodeStyles = function (_) { return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    background-color: ", ";\n    color: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    background-color: ", ";\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.code;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.code.fontSize;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastBackgroundColor.toString()
        : 'transparent';
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastColor.toString()
        : 'auto';
}); };
var Code = styled_components_1.default.pre(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n\n    padding: ", ";\n"], ["\n    ", "\n\n    padding: ", ";\n"])), baseCodeStyles, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.code.padding.toString();
});
var InlineCode = styled_components_1.default.code(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n\n    display: inline-block;\n    padding: 0 ", ";\n    margin: 0 ", ";\n"], ["\n    ", "\n\n    display: inline-block;\n    padding: 0 ", ";\n    margin: 0 ", ";\n"])), baseCodeStyles, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs.toString();
});
exports.textStyles = {
    Jumbo: Jumbo,
    Big: Big,
    Normal: Normal,
    Small: Small,
    Micro: Micro,
    Notification: Notification,
    Quote: Quote,
    Author: Author,
    Code: Code,
    InlineCode: InlineCode,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=textStyles.js.map